"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schema = exports.url = exports.subjectOf = exports.sameAs = exports.potentialAction = exports.name = exports.mainEntityOfPage = exports.image = exports.identifier = exports.disambiguatingDescription = exports.description = exports.alternateName = exports.additionalType = exports.width = exports.penciler = exports.letterer = exports.inker = exports.height = exports.depth = exports.colorist = exports.artworkSurface = exports.birthDate = exports.givenName = exports.familyName = exports.datePublished = exports.dateCreated = exports.artMedium = exports.artist = exports.artform = exports.artEdition = exports.ImageObject = exports.Action = exports.PropertyValue = exports.Project = exports.VisualArtwork = exports.Person = exports.CreativeWork = exports._self = exports.ns = exports.loadData = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
const _this = __importStar(require("./schema"));
var loadData = () => {
    return JSONLD_1.JSONLD.parsePromises(Promise.resolve().then(() => __importStar(require('../data/schema.json'))), Promise.resolve().then(() => __importStar(require('../data/schema-added.json'))));
};
exports.loadData = loadData;
//NOTE: we have changed the usual namespace https://schema.org/ to http://schema.org/ because tools like jsonld will convert all URI's to HTTP
//for now, our approach is therefor to convert to & use http versions only. schema.json has been adjusted too, and all namespaces in other files should use http://schema.org
exports.ns = (0, NameSpace_1.createNameSpace)('http://schema.org/');
exports._self = (0, exports.ns)('');
// Classes
exports.CreativeWork = (0, exports.ns)('CreativeWork');
exports.Person = (0, exports.ns)('Person');
exports.VisualArtwork = (0, exports.ns)('VisualArtwork');
exports.Project = (0, exports.ns)('Project');
exports.PropertyValue = (0, exports.ns)('PropertyValue');
exports.Action = (0, exports.ns)('Action');
exports.ImageObject = (0, exports.ns)('ImageObject');
// Properties
exports.artEdition = (0, exports.ns)('artEdition');
exports.artform = (0, exports.ns)('artform');
exports.artist = (0, exports.ns)('artist');
exports.artMedium = (0, exports.ns)('artMedium');
exports.dateCreated = (0, exports.ns)('dateCreated');
exports.datePublished = (0, exports.ns)('datePublished');
exports.familyName = (0, exports.ns)('familyName');
exports.givenName = (0, exports.ns)('givenName');
exports.birthDate = (0, exports.ns)('birthDate');
exports.artworkSurface = (0, exports.ns)('artworkSurface');
exports.colorist = (0, exports.ns)('colorist');
exports.depth = (0, exports.ns)('depth');
exports.height = (0, exports.ns)('height');
exports.inker = (0, exports.ns)('inker');
exports.letterer = (0, exports.ns)('letterer');
exports.penciler = (0, exports.ns)('penciler');
exports.width = (0, exports.ns)('width');
exports.additionalType = (0, exports.ns)('additionalType');
exports.alternateName = (0, exports.ns)('alternateName');
exports.description = (0, exports.ns)('description');
exports.disambiguatingDescription = (0, exports.ns)('disambiguatingDescription');
exports.identifier = (0, exports.ns)('identifier');
exports.image = (0, exports.ns)('image');
exports.mainEntityOfPage = (0, exports.ns)('mainEntityOfPage');
exports.name = (0, exports.ns)('name');
exports.potentialAction = (0, exports.ns)('potentialAction');
exports.sameAs = (0, exports.ns)('sameAs');
exports.subjectOf = (0, exports.ns)('subjectOf');
exports.url = (0, exports.ns)('url');
exports.schema = {
    // Classes
    CreativeWork: exports.CreativeWork,
    Person: exports.Person,
    VisualArtwork: exports.VisualArtwork,
    Project: exports.Project,
    PropertyValue: exports.PropertyValue,
    Action: exports.Action,
    ImageObject: exports.ImageObject,
    // Properties
    additionalType: exports.additionalType,
    alternateName: exports.alternateName,
    description: exports.description,
    disambiguatingDescription: exports.disambiguatingDescription,
    identifier: exports.identifier,
    image: exports.image,
    mainEntityOfPage: exports.mainEntityOfPage,
    name: exports.name,
    potentialAction: exports.potentialAction,
    sameAs: exports.sameAs,
    subjectOf: exports.subjectOf,
    url: exports.url,
    artform: exports.artform,
    artist: exports.artist,
    artworkSurface: exports.artworkSurface,
    colorist: exports.colorist,
    depth: exports.depth,
    height: exports.height,
    inker: exports.inker,
    letterer: exports.letterer,
    penciler: exports.penciler,
    width: exports.width,
    artEdition: exports.artEdition,
    artMedium: exports.artMedium,
    dateCreated: exports.dateCreated,
    datePublished: exports.datePublished,
    birthDate: exports.birthDate,
    familyName: exports.familyName,
    givenName: exports.givenName,
};
(0, package_1.linkedOntology)(_this, exports.ns, 'schema', exports.loadData, ['../data/schema.json', '../data/schema-added.json']);
//# sourceMappingURL=schema.js.map